import opelin from '../emuActions/opelin.json';
import man from '../emuActions/man.json';
import resp from '../emuActions/resp.json';
import newrdi from '../emuActions/newrdi.json';
import viewrdi from '../emuActions/viewrdi.json';
import start from '../emuActions/start.json';
import report from '../emuActions/report.json';
import assign from '../emuActions/assign.json';
import activities from '../emuActions/activities.json';
import reports from '../emuActions/reports.json';
import stats from '../emuActions/stats.json';
import gotohomeopelin from '../emuActions/gotohomeopelin.json';
import gotohomeman from '../emuActions/gotohomeman.json';
import gotohomeresp from '../emuActions/gotohomeresp.json';

export default {
    opelin,
    man,
    resp,
    newrdi,
    viewrdi,
    assign,
    start,
    report,
    activities,
    reports,
    stats,
    gotohomeopelin,
    gotohomeman,
    gotohomeresp
}